//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, Form, ButtonStyle } from '@cmp/common';
import { withTranslation } from 'react-i18next'; //------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { ScreenSet, showScreenSet } from '@helpers/gigya';
import { removeEmptyAddresses } from '@helpers/gigya';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class MobileMenu extends React.Component {
  render() {
    const { t } = this.props;
    const componentClasses = classNames(styles.MobileMenu);

    return (
      <div className={componentClasses}>
        <Button to="/login" className={styles.Link} style={ButtonStyle.Link}>
          {t('landing_SignIn')}
        </Button>
        <Button to="/signup" className={styles.Link} style={ButtonStyle.Link}>
          {t('landing_Register')}
        </Button>
        <Button to="/about" className={styles.Link} style={ButtonStyle.Link}>
          {t('landing_About')}
        </Button>
        <Button to="/support" className={styles.Link} style={ButtonStyle.Link}>
          {t('landing_Support')}
        </Button>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(MobileMenu);
